// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { VOTING_STATUS_CHANNELS } from "@sequentech/ui-core";
export var toVotersByChannelRows = function (data) {
    var _a;
    var counts = new Map((_a = data === null || data === void 0 ? void 0 : data.map(function (_a) {
        var channel = _a.channel, count = _a.count;
        return [channel, count];
    })) !== null && _a !== void 0 ? _a : []);
    return VOTING_STATUS_CHANNELS.map(function (channel) {
        var _a;
        return ({
            channel: channel,
            count: (_a = counts.get(channel)) !== null && _a !== void 0 ? _a : 0,
        });
    }).filter(function (_a) {
        var count = _a.count;
        return count > 0;
    });
};
